module.exports = __webpack_public_path__ + "img/blood-1.e08fc31e.png";